import { LiveClass } from '../models/LiveClassDto.model';

function itsAprovaLiveRecordAvailable(event: LiveClass) {
  const hasSomeToken = !!(
    event.vimeoId ||
    event.youtubeUrl ||
    event.sambatechToken
  );
  if (!event.expirationDate && hasSomeToken) {
    return true;
  }

  if (!event.expirationDate) {
    return false;
  }

  const now = new Date();
  const expirationDate = new Date(event.expirationDate);

  return now < expirationDate && hasSomeToken;
}

export { itsAprovaLiveRecordAvailable };
